(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["banky-black-friday"] && !Shopify.designMode) return;
  try {
    /* Black Friday: een pagina die Shopify nog uit de cache serveert na het einde, of die openstaat over het einde heen,
   verbergt het embleem (html.bf-voorbij; zonder verschuiving, de witte strook blijft). De aftelling regelt dit zelf. */
(function () {
  var el = document.querySelector('.bf-embleem[data-eind]');
  if (!el) return;
  var rest = Date.parse(el.getAttribute('data-eind')) - Date.now();
  var uit = function () { document.documentElement.classList.add('bf-voorbij'); };
  if (!(rest > 0)) uit();
  else if (rest < 864e5) setTimeout(uit, rest);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["banky-product-focus"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('banky-product-focus')) {
  customElements.define('banky-product-focus', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.measure = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          this.dataset.fits = 'true';
          const top = parseFloat(getComputedStyle(this).top) || 0;
          this.dataset.fits = String(window.innerWidth >= 1000 && this.getBoundingClientRect().height + top + 24 <= window.innerHeight);
        });
      };
      this.observer = new ResizeObserver(this.measure);
      this.observer.observe(this);
      const header = document.querySelector('store-header');
      if (header) this.observer.observe(header);
      window.addEventListener('resize', this.measure, { signal: this.abort.signal, passive: true });
      this.measure();
      this.kolomMaat();
    }
    /* Banky Nieuw, feedback Geert 30-09 (F5): de linkerkolom (galerij en voordelen) en de koopbox rechts lopen vanaf 1000px mee;
       de kortste kolom schuift mee tot zijn onderkant 20px boven de onderrand van het venster staat en blijft daar tot de rij eindigt.
       Soepel scrollen (Geert 20-10-2026: "check ook het scrollen op product pagina web secties gaat soms een beetje stotterend"; keuze
       "Volledig soepel (Aanbevolen)"): dat doet nu alleen CSS sticky (banky-pagina-product.css blok F5, banky-bril.css deel 1), met
       top = kleinste van kop plus 20px en schermhoogte min kolomhoogte min 20px. Dit script zet alleen die kolomhoogte als
       --banky-kolom-h op beide kolommen, als hun hoogte verandert (ResizeObserver), nooit tijdens het scrollen; onder 1000px niets.
       Tot 21-10 zette kolomVolgen (links) en Halo's safe-sticky (rechts) bij elke scroll een inline top die een frame achter de
       pagina aan kwam (inhaalsprongen van 38px). Bewust gevolg: omhoog scrollen houdt een kolom die langer is dan het scherm onderaan
       uitgelijnd tot de bovenkant van de rij terugkomt (vervangt F5 van 30-09, waarbij de bovenkant meteen terugkwam).
       Snelheidsronde 2 (05-10-2026): de galerij staat in de bron vóór de koopbox; main-product.liquid zet hem vanaf 1000px tijdens het
       lezen terug in deze kolom, dus hier is de kolom weer galerij plus voordelen. Draaide dat script niet (de pagina werd smaller
       dan 1000px geopend), dan volgt alleen het voordelenblok. */
    kolomMaat() {
      const kolom = this.closest('.banky-product-visual');
      if (!kolom || !('ResizeObserver' in window)) return;
      const koopbox = kolom.parentElement && kolom.parentElement.querySelector(':scope > [data-banky-koopbox]');
      const kolommen = [kolom, koopbox].filter(Boolean);
      const breed = window.matchMedia('(min-width: 1000px)');
      this.kolomObserver = new ResizeObserver(items => {
        if (!breed.matches) return;
        for (const x of items) {
          const maat = x.borderBoxSize && x.borderBoxSize[0];
          const h = Math.round(maat ? maat.blockSize : x.target.offsetHeight) + 'px';
          if (x.target.style.getPropertyValue('--banky-kolom-h') !== h) x.target.style.setProperty('--banky-kolom-h', h);
        }
      });
      const kijk = () => kolommen.forEach(k => { this.kolomObserver.unobserve(k); this.kolomObserver.observe(k); });
      kijk();
      breed.addEventListener('change', kijk, { signal: this.abort.signal });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.kolomObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
